import React from 'react';
import styled, { withTheme } from 'styled-components';

import { nf } from '~/utils';

const Wrapper = styled.div`
  position: absolute;
  pointer-events: none;
  background: white;
  padding: 10px;
  top: 0;
  left: 0;
  z-index: 10;
  line-height: 1.2;
  border: 1px solid #eee;
  border-radius: 4px;
  width: 220px;
  user-select: none;
`;

const Tooltip = ({
  data,
  xScale,
  yScale,
  format,
  ySelector,
  isRelView,
  isZoomView,
  year,
  percentile,
  theme,
}) => {
  if (!data) {
    return null;
  }

  const xValue = data[config.columns.PERCENTAGE];
  const x = xScale(xValue);
  const yValue = data[ySelector];
  const yLabel = nf(yValue, format);
  const y = yScale(yValue);
  const xGlobal = percentile[config.columns.PERCENTAGE];

  const text = `${yLabel} ${isRelView ? 'Prozent' : 'Euro'}`;
  const inverted =
    (isZoomView && xValue > xGlobal) || (!isZoomView && xValue > 50);

  return (
    <Wrapper
      style={{
        left: x,
        top: y + 10,
        transform: `translate(${inverted ? '-100%' : 0}, -100%)`,
      }}
      className="tooltip"
    >
      <div>
        <strong>{year}</strong> zahlte das <strong>{xValue}.</strong> Prozent
        der Einkommensverteilung je Erwachsenem durchschnittlich
        <br />
        <span style={{ color: theme.colors.highlight, fontWeight: 700 }}>
          {text}
        </span>{' '}
        Einkommensteuer.
      </div>
    </Wrapper>
  );
};

export default withTheme(Tooltip);
